// extracted by mini-css-extract-plugin
export var chip = "_91-0";
export var filterDropdown = "_91-5";
export var filterItem = "_91-6";
export var icon = "_91-1";
export var removeButton = "_91-3";
export var removeIcon = "_91-4";
export var separator = "_91-2";